module Factive.Game
{
    export class SoundConstants
    {
        public static ACHIEVE_COLLECT:string = "achieve_collect";
        public static BG_MUSIC:string = "bg_music";
        public static BUTTON_CLICK:string = "button_click";
        public static BUTTON_ROLLOVER:string = "button_rollover";
        public static DICE:string = "dice";
        public static SCRIBBLE:string = "scribble";
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Constants/SoundConstants.ts